export const changeNoteColorMenuText = "VDDIt";
export default {changeNoteColorMenuText};